import { configureStore } from "@reduxjs/toolkit";

import userReducer from "../features/userSlice";
import modalReducer from "../features/modalSLice";
import usersReducer from "../features/usersSlice";
import rolesReducer from "../features/rolesSlice";
import tasksReducer from "../features/tasksSlice";
import donorsReducer from "../features/donorsSlice";
import configReducer from "../features/configSlice";
import reportsReducer from "../features/reportsSlice";
import nationsReducer from "../features/nationsSlice";
import regionsReducer from "../features/regionsSlice";
import projectsReducer from "../features/projectsSlice";
import accountsReducer from "../features/accountsSlice";
import countriesReducer from "../features/countriesSlice";
import currenciesReducer from "../features/currenciesSlice";
import milestonesReducer from "../features/milestonesSlice";
import departmentsReducer from "../features/departmentSlice";
import communitiesReducer from "../features/communitiesSlice";
import transactionsReducer from "../features/transactionsSlice";
import taskStatusesReducer from "../features/taskStatusesSlice";
import organizationsReducer from "../features/organizationsSlice";
import projectStatusesReducer from "../features/projectStatusesSlice";

export const store = configureStore({
  reducer: {
    user: userReducer,
    users: usersReducer,
    tasks: tasksReducer,
    modal: modalReducer,
    roles: rolesReducer,
    config: configReducer,
    donors: donorsReducer,
    reports: reportsReducer,
    regions: regionsReducer,
    nations: nationsReducer,
    accounts: accountsReducer,
    projects: projectsReducer,
    countries: countriesReducer,
    milestones: milestonesReducer,
    currencies: currenciesReducer,
    communities: communitiesReducer,
    departments: departmentsReducer,
    transactions: transactionsReducer,
    taskStatuses: taskStatusesReducer,
    organizations: organizationsReducer,
    projectStatuses: projectStatusesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),

  // middleware: (getDefaultMiddleware) => {
  //   getDefaultMiddleware({ thunk: {}, serializableCheck: true }).concat();
  // },

  devTools: !process.env.NODE_ENV === "development",
});
